import "./fullscreen-view.scss";

import React, { FC } from "react";

const FullScreenView: FC<any> = (props) => {
  return <div className="fsv-container">{props.children}</div>;
};

export default FullScreenView;
